module.exports = __webpack_public_path__ + "static/media/interaccion-COMUNICACION.13dc4505.svg";